export default __webpack_public_path__ + "static/media/need_help.0d7086c1.wav";